import Avatar, {AvatarProps} from '@mui/material/Avatar';
import AvatarGroup, {AvatarGroupProps} from '@mui/material/AvatarGroup';

import {styled} from '@mui/material/styles';

export const CAvatar = styled(Avatar)<AvatarProps>(
  (/* { theme } */) => ({
  }),
);

export const CAvatarGroup = styled(AvatarGroup)<AvatarGroupProps>(
  (/* { theme } */) => ({
  }),
);
